import {
  BreakPointCondition,
  Icon,
  Input,
  Text,
  useBreakpointIf,
  HStack,
  VStack,
} from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Button, Pressable } from 'native-base';
import { useCallback, useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { FilterModal } from '../../../../components/FilterModal';
import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { productManagementMobileFilterState } from '../../../../store/ProducManagement/atom';
import { useFilterProductsManagement } from '../../hooks/useFilterProductsManagement';

interface FilterMobileProps {
  isLoading: boolean;
  handleChangeTab: (index: number) => void;
}
export const FilterMobile = ({ isLoading, handleChangeTab }: FilterMobileProps) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { appliedFilters } = useRecoilValue(productManagementMobileFilterState);

  const {
    filterForm,
    handleInputBlur,
    handleClearSearchTerm,
    setSearchTerm,
    handleBlockTypeFilter,
  } = useFilterProductsManagement();

  useEffect(() => {
    if (appliedFilters.length > 0) {
      const { blockType, tabIndex } = appliedFilters.reduce(
        (acc, filterOption) => {
          if (filterOption.fieldName === 'tabs' && Array.isArray(filterOption.filter)) {
            acc.tabIndex = Number(filterOption.filter[0]);
          }

          if (filterOption.fieldName === 'blockType' && Array.isArray(filterOption.filter)) {
            acc.blockType = filterOption.filter[0];
          }

          return acc;
        },
        { tabIndex: 0, blockType: '' }
      );

      handleBlockTypeFilter(blockType);
      handleChangeTab(tabIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters]);

  return (
    <VStack w="full" space={Spacing['inline.xxxs']}>
      <Input
        placeholder="Pesquise por Nome, CNPJ, Gestor ou Emissor"
        noValidate={true}
        name="searchTerm"
        onSubmitEditing={filterForm.handleSubmit(setSearchTerm)}
        control={filterForm.control}
        onBlur={handleInputBlur}
        isDisabled={isLoading}
        error={filterForm.formState.errors.searchTerm}
        autoComplete="off"
        variant="rounded"
        inputRightElement={
          <Pressable
            onPress={() => {
              filterForm.formState.isValid ? handleClearSearchTerm() : null;
            }}
            pr={filterForm.formState.isValid ? 3 : 4}
            isDisabled={isLoading}>
            <Icon name={filterForm.formState.isValid ? 'Close' : 'Search'} size="xxxs" />
          </Pressable>
        }
      />
      <Button
        isLoadingText="Filtrar"
        maxW="100px"
        spinnerPlacement="end"
        _text={{ textTransform: 'none' }}
        disabled={isLoading}
        onPress={() => navigate('ProductManagementFiltersModal')}
        paddingX={Spacing['inline.xxxs']}
        marginY={Spacing['stack.nano']}
        variant="secondary"
        {...(!appliedFilters.length && { rightIcon: <Icon name="Funnel" size="xxxs" /> })}>
        <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
          <Text variant="semibold" fontSize={Typography['fontsize.md']}>
            Filtrar
          </Text>
          {!!appliedFilters.length && (
            <Box
              rounded="full"
              w="20px"
              h="20px"
              alignItems="center"
              justifyContent="center"
              bg={'brand.tertiary.light'}>
              <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.white">
                {appliedFilters.length}
              </Text>
            </Box>
          )}
        </HStack>
      </Button>
    </VStack>
  );
};

export const ProductManagementFiltersModal = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <FilterModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      filterAtom={productManagementMobileFilterState}
    />
  );
};
